import { createSlice } from "@reduxjs/toolkit";
import { getTermsAndConditionsAPI } from "../../../services/guestUsers/guestUserAllAPIService";
const data = {
  isLoading: false,
  error: "",
  message: "",
  data: null,
};

const getTermsAndConditionSlice = createSlice({
  name: "getTermsAndConditionSlice",
  initialState: data,
  reducers: {
    getTermsAndConditionSliceInfo(state) {
      state.isLoading = true;
    },
    getTermsAndConditionSliceSuccess(state, action) {
      state.isLoading = false;
      state.data = action.payload;
      state.message = "";
    },
    getTermsAndConditionSliceFailure(state, action) {
      state.isLoading = false;
      state.message = action.payload;
      state.data = null;
    },
    getTermsAndConditionSliceReset(state) {
      state.isLoading = false;
      state.message = "";
      state.data = null;
      state.error = "";
    },
  },
});

export const getTermsAndConditionHandler = (data) => async (dispatch) => {
  try {
    dispatch(getTermsAndConditionSliceAction.getTermsAndConditionSliceInfo());
    const response = await getTermsAndConditionsAPI(data);
    dispatch(
      getTermsAndConditionSliceAction.getTermsAndConditionSliceSuccess(
        response,
      ),
    );
  } catch (e) {
    dispatch(
      getTermsAndConditionSliceAction.getTermsAndConditionSliceFailure(e),
    );
  }
};
export default getTermsAndConditionSlice.reducer;
export const getTermsAndConditionSliceAction =
  getTermsAndConditionSlice.actions;
